import { useMemo } from "react";
import { useLocation } from "../../../core/location-provider";

/** URL 쿼리 파라미(lat, lng, loadAddr, firstVisit) 파싱 및 위치 키 계산 */
export function useHomeQueryParams() {
  const { hasLastLo, getLocationFromStorage } = useLocation();
  const queryParams =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search)
      : new URLSearchParams();
  const lat = queryParams.get("lat");
  const lng = queryParams.get("lng");
  const loadAddr = queryParams.get("loadAddr");
  const firstVisit = queryParams.get("firstVisit");

  // 현재 위치 정보 (위치가 변경되면 저장된 데이터 무효화용)
  const currentLocationKey = useMemo(() => {
    const currentLat = lat
      ? Number(lat)
      : hasLastLo
        ? getLocationFromStorage().lat
        : null;
    const currentLng = lng
      ? Number(lng)
      : hasLastLo
        ? getLocationFromStorage().lng
        : null;
    return `${currentLat}-${currentLng}`;
  }, [lat, lng, hasLastLo, getLocationFromStorage]);

  const latNum = lat
    ? Number(lat)
    : hasLastLo
      ? getLocationFromStorage().lat
      : null;
  const lngNum = lng
    ? Number(lng)
    : hasLastLo
      ? getLocationFromStorage().lng
      : null;

  return {
    lat,
    lng,
    latNum,
    lngNum,
    loadAddr,
    firstVisit,
    currentLocationKey,
    hasLastLo,
    getLocationFromStorage,
  };
}
